export default {
  "atlas-passive-mastery/atlaspassivemasteryabyss.webp": "d90d73d2",
  "atlas-passive-mastery/atlaspassivemasteryalva.webp": "d16879fe",
  "atlas-passive-mastery/atlaspassivemasteryanarchy.webp": "19c68257",
  "atlas-passive-mastery/atlaspassivemasterybestiary.webp": "9c1e7d63",
  "atlas-passive-mastery/atlaspassivemasterybeyond.webp": "a19c3b80",
  "atlas-passive-mastery/atlaspassivemasteryblight.webp": "0a234532",
  "atlas-passive-mastery/atlaspassivemasteryboss.webp": "f839bda7",
  "atlas-passive-mastery/atlaspassivemasterybreach.webp": "167e795f",
  "atlas-passive-mastery/atlaspassivemasterycleansingfire.webp": "9d1a41da",
  "atlas-passive-mastery/atlaspassivemasteryconqueror.webp": "4680e7bc",
  "atlas-passive-mastery/atlaspassivemasterydelirium.webp": "b3bc87b2",
  "atlas-passive-mastery/atlaspassivemasterydelve.webp": "01eca256",
  "atlas-passive-mastery/atlaspassivemasterydomination.webp": "9cf3ceb5",
  "atlas-passive-mastery/atlaspassivemasteryeldershaper.webp": "10afe2e1",
  "atlas-passive-mastery/atlaspassivemasteryempty.webp": "e8b1e36e",
  "atlas-passive-mastery/atlaspassivemasteryessence.webp": "4cb5214c",
  "atlas-passive-mastery/atlaspassivemasteryexpedition.webp": "3452221c",
  "atlas-passive-mastery/atlaspassivemasteryharbinger.webp": "f7d317ac",
  "atlas-passive-mastery/atlaspassivemasteryharvest.webp": "6587d96d",
  "atlas-passive-mastery/atlaspassivemasteryheist.webp": "d480ceb6",
  "atlas-passive-mastery/atlaspassivemasteryinvasion.webp": "109cca51",
  "atlas-passive-mastery/atlaspassivemasteryjun.webp": "1dc819a9",
  "atlas-passive-mastery/atlaspassivemasterykirac.webp": "3e259f0a",
  "atlas-passive-mastery/atlaspassivemasterylabyrinth.webp": "c1af154a",
  "atlas-passive-mastery/atlaspassivemasterylegion.webp": "c2e3de44",
  "atlas-passive-mastery/atlaspassivemasterymap.webp": "4e9efae0",
  "atlas-passive-mastery/atlaspassivemasterymaven.webp": "eef6a8e7",
  "atlas-passive-mastery/atlaspassivemasterymetamorph.webp": "d785ebc7",
  "atlas-passive-mastery/atlaspassivemasteryquality.webp": "c70a51a6",
  "atlas-passive-mastery/atlaspassivemasteryrare.webp": "b6cf87d9",
  "atlas-passive-mastery/atlaspassivemasteryritual.webp": "ef77abc5",
  "atlas-passive-mastery/atlaspassivemasteryscarab.webp": "bedcf945",
  "atlas-passive-mastery/atlaspassivemasterysextant.webp": "2886bc7a",
  "atlas-passive-mastery/atlaspassivemasterystrongbox.webp": "ef715245",
  "atlas-passive-mastery/atlaspassivemasterysynthesis.webp": "bcc980fc",
  "atlas-passive-mastery/atlaspassivemasterytangle.webp": "965ee68c",
  "atlas-passive-mastery/atlaspassivemasterytorment.webp": "5a944746",
  "atlas-passive-mastery/atlaspassivemasteryunique.webp": "3b44ffa8",
  "atlas-passive-mastery/atlaspassivemasteryvaal.webp": "95daa72b",
  "atlas_passive_tree.bundle": "e2d1a347",
  "banners/build-banners/ascendant.webp": "b476629a",
  "banners/build-banners/assasin.webp": "a0d24b4e",
  "banners/build-banners/berserker.webp": "ef2cdd5e",
  "banners/build-banners/champion.webp": "4b0b3453",
  "banners/build-banners/chieftain.webp": "0c7608df",
  "banners/build-banners/deadeye.webp": "38c5e305",
  "banners/build-banners/dex.webp": "adf3937b",
  "banners/build-banners/dexint.webp": "089762ff",
  "banners/build-banners/elementalist.webp": "c95482b2",
  "banners/build-banners/gladiator.webp": "f7bac6b3",
  "banners/build-banners/guardian.webp": "3f857241",
  "banners/build-banners/hierophant.webp": "1c0649d7",
  "banners/build-banners/inquisitor.webp": "a30349e0",
  "banners/build-banners/int.webp": "317899ed",
  "banners/build-banners/juggernaut.webp": "31d4fe18",
  "banners/build-banners/necromancer.webp": "25fe512c",
  "banners/build-banners/occultist.webp": "035ad080",
  "banners/build-banners/pathfinder.webp": "8e60cfe5",
  "banners/build-banners/raider.webp": "877ef355",
  "banners/build-banners/saboteur.webp": "0836423e",
  "banners/build-banners/slayer.webp": "f2289f0c",
  "banners/build-banners/str.webp": "64256ba8",
  "banners/build-banners/strdex.webp": "5963d63e",
  "banners/build-banners/strdexint.webp": "e786a258",
  "banners/build-banners/strint.webp": "edc761d1",
  "banners/build-banners/trickster.webp": "9596fc11",
  "banners/build-banners/warden.webp": "877ef355",
  "banners/buttons/poe-community-tab.webp": "4cd50f23",
  "banners/buttons/poe-maxroll-tab.webp": "060b4073",
  "banners/buttons/poe-planner-tab.webp": "e6f07412",
  "banners/filter-banners/all-class-thumb.webp": "f4dc668d",
  "banners/filter-banners/all-class-thumb2.webp": "af7e7fb9",
  "banners/filter-banners/all-class-thumb3.webp": "c458134a",
  "banners/filter-banners/all2-class-thumb.webp": "28a63e0f",
  "banners/filter-banners/ascendancy.webp": "60d6eb70",
  "banners/filter-banners/ascendancy2.webp": "e8c4b4b0",
  "banners/filter-banners/ascendancy3.webp": "82511035",
  "banners/filter-banners/dex-class-thumb.webp": "b2b5fc72",
  "banners/filter-banners/dexint-class-thumb.webp": "ef2d4967",
  "banners/filter-banners/dexint2-class-thumb.webp": "099e18ac",
  "banners/filter-banners/int-class-thumb.webp": "ac4e768d",
  "banners/filter-banners/int2-class-thumb.webp": "a6dc576d",
  "banners/filter-banners/str-class-thumb.webp": "b2ce7973",
  "banners/filter-banners/strdex-class-thumb.webp": "f538446f",
  "banners/filter-banners/strdex2-class-thumb.webp": "800344ab",
  "banners/filter-banners/strdexint-class-thumb.webp": "bc96878f",
  "banners/filter-banners/strint-class-thumb.webp": "da4effa9",
  "banners/filter-banners/strint2-class-thumb.webp": "b52d47b0",
  "data.min.json": "07488360",
  "gemAcquisition.min.json": "90475146",
  "glyph.png": "be6e9c92",
  "harb1.png": "3ad176a7",
  "harb2.png": "3b07f06d",
  "harb3.png": "f812f2b4",
  "icons/armour.svg": "59589c20",
  "icons/attack-speed.svg": "32d7a0d5",
  "icons/chaos.svg": "083f60db",
  "icons/cold.svg": "497b77fe",
  "icons/crit-chance.svg": "058cd71f",
  "icons/crit-multi.svg": "1bb031db",
  "icons/dot.svg": "78877b11",
  "icons/evade.svg": "8d758659",
  "icons/evasion.svg": "bb7a702a",
  "icons/fire.svg": "1f4ae48b",
  "icons/heart.svg": "375195ba",
  "icons/heart2.svg": "616b79dc",
  "icons/hit-chance.svg": "0e989459",
  "icons/lightning.svg": "ecc724e6",
  "icons/shield.svg": "71ec0756",
  "icons/shield2.svg": "4f5c7ffc",
  "icons/speed.svg": "07a9234c",
  "icons/sword.svg": "c6bcb93d",
  "illustrations/AssassinAscendency.webp": "01d0e362",
  "illustrations/BeserkerAscendency.webp": "443e57de",
  "illustrations/ChampionAscendency.webp": "0fa30e96",
  "illustrations/ChieftainAscendency.webp": "815e0209",
  "illustrations/DeadeyeAscendency.webp": "34db6f6e",
  "illustrations/Dex.webp": "8a983818",
  "illustrations/DexInt.webp": "d52e8fab",
  "illustrations/ElementalistAscendency.webp": "2548871d",
  "illustrations/GladiatorAscendency.webp": "53af3d3d",
  "illustrations/GuardianAscendency.webp": "7775e182",
  "illustrations/HierophantAscendency.webp": "526b77a6",
  "illustrations/InquisitorAscendency.webp": "3e43a090",
  "illustrations/Int.webp": "696abf11",
  "illustrations/JuggernaughtAscendency.webp": "feb8c02b",
  "illustrations/NecromancerAscendency.webp": "9286a4b4",
  "illustrations/OccultistAscendency.webp": "e9eb9a0a",
  "illustrations/PathfinderAscendency.webp": "77e9a4b5",
  "illustrations/RaiderAscendency.webp": "bf626851",
  "illustrations/SaboteurAscendency.webp": "5931e05d",
  "illustrations/SlayerAscendency.webp": "a68451cc",
  "illustrations/Str.webp": "8d5c58ac",
  "illustrations/StrDex.webp": "118cd06e",
  "illustrations/StrInt.webp": "dc733603",
  "illustrations/TricksterAscendency.webp": "9b9d5a78",
  "items/amulets.webp": "1679e1a4",
  "items/armours.bodyarmours.webp": "5a44fb94",
  "items/armours.boots.webp": "ac0ab735",
  "items/armours.gloves.webp": "d818a7c7",
  "items/armours.helmets.harbingershards.webp": "ae0e44e8",
  "items/armours.helmets.webp": "43e04920",
  "items/armours.microtransactions.webp": "42aba039",
  "items/armours.shields.shards.webp": "4bb63efb",
  "items/armours.shields.webp": "1c00a919",
  "items/belts.shards.webp": "1aedf6a6",
  "items/belts.webp": "857897fb",
  "items/bufficons.webp": "54e1f801",
  "items/currency.ancestors.webp": "777d7f2e",
  "items/currency.archnemesis.webp": "5d39fe7e",
  "items/currency.atlas.webp": "fb915a39",
  "items/currency.azmeri.webp": "25ab5026",
  "items/currency.bestiary.webp": "08d69d1f",
  "items/currency.breach.webp": "48fee388",
  "items/currency.catalysts.webp": "76e5f20e",
  "items/currency.classic.webp": "8072f0a4",
  "items/currency.crucible.webp": "9929fc06",
  "items/currency.delirium.webp": "79be603a",
  "items/currency.delve.webp": "a0702f85",
  "items/currency.essence.webp": "7c430185",
  "items/currency.expedition.webp": "aaffe257",
  "items/currency.harvest.webp": "839bfaa5",
  "items/currency.heist.webp": "933485f4",
  "items/currency.hellscape.webp": "d532ac33",
  "items/currency.incubation.webp": "d742f6f0",
  "items/currency.influence exalts.webp": "1c937e01",
  "items/currency.lake.webp": "9e4e1151",
  "items/currency.legion.webp": "ac940e7f",
  "items/currency.memoryline.webp": "0be9672f",
  "items/currency.metamorph.webp": "465cc36b",
  "items/currency.necropolis.webp": "34608c21",
  "items/currency.oils.webp": "39ece5de",
  "items/currency.old icons.webp": "0005cf5e",
  "items/currency.ritual.webp": "7731b0b6",
  "items/currency.ruthless.webp": "62b7bf1c",
  "items/currency.sanctum.webp": "8ac0e9ba",
  "items/currency.scarabs.webp": "f27bde34",
  "items/currency.secretsoftheatlas.webp": "7e51cc68",
  "items/currency.sentinel.webp": "88917a73",
  "items/currency.settlers.webp": "1c0ad702",
  "items/currency.strongholds.webp": "adae492c",
  "items/currency.webp": "e4386704",
  "items/divination.images.webp": "6b2f590f",
  "items/divination.webp": "df707fcb",
  "items/effects.armourset.webp": "c69ed46b",
  "items/effects.auras.webp": "ee5f245e",
  "items/effects.belts.webp": "0076848f",
  "items/effects.bodyarmour.webp": "0475035e",
  "items/effects.character.webp": "92bb0b39",
  "items/effects.cnitems.cnbadges.webp": "203df1c8",
  "items/effects.cnitems.cnframes.1.webp": "3599bd5f",
  "items/effects.cnitems.cnframes.2.webp": "b332a2a5",
  "items/effects.cnitems.cnframes.3.webp": "d090e6e4",
  "items/effects.cnitems.cnframes.4.webp": "2770a3df",
  "items/effects.cnitems.cnframes.5.webp": "47667f3e",
  "items/effects.cnitems.cnframes.6.webp": "36eb5726",
  "items/effects.cnitems.cnframes.7.webp": "b85c4cf9",
  "items/effects.cnitems.cnframes.webp": "110d6735",
  "items/effects.cnitems.cnportraits.webp": "a325dc5c",
  "items/effects.consumerables.webp": "0702e469",
  "items/effects.cursors.webp": "0385f962",
  "items/effects.flask.webp": "d8f91119",
  "items/effects.footprints.webp": "54f4aed1",
  "items/effects.frames.webp": "ee24e81d",
  "items/effects.gloves.webp": "da98b78e",
  "items/effects.hats.webp": "e52881c9",
  "items/effects.jewellery.webp": "71fc7892",
  "items/effects.mysterychest.webp": "82057f1a",
  "items/effects.portals.webp": "a2a261b4",
  "items/effects.shields.webp": "3fdc9fc0",
  "items/effects.shoes.webp": "1e279d81",
  "items/effects.weapon.webp": "104dbedf",
  "items/effects.webp": "4fa68097",
  "items/effects.wings.webp": "6fc79269",
  "items/effects.wrappingpaper.webp": "a920f9b0",
  "items/flasks.overlays.webp": "1bac24ce",
  "items/flasks.utilities.webp": "323fd991",
  "items/flasks.webp": "31680c4a",
  "items/garena.webp": "953e0b0d",
  "items/gems.overlays.webp": "5d24feaa",
  "items/gems.support.supportplus.webp": "7ab341e2",
  "items/gems.support.webp": "c8ee64e5",
  "items/gems.vaalgems.webp": "b2dc9a0a",
  "items/gems.webp": "f12d7775",
  "items/hideout.interactive.webp": "e23759e1",
  "items/hideout.webp": "6a410aec",
  "items/jewels.webp": "eadc3091",
  "items/maps.act4maps.webp": "0f6f5136",
  "items/maps.atlas2maps.new.uniquemaps.webp": "32bf7913",
  "items/maps.atlas2maps.new.webp": "22f982dc",
  "items/maps.atlas2maps.new1.uniquemaps.webp": "94d8727a",
  "items/maps.atlas2maps.new1.webp": "1296d88e",
  "items/maps.atlas2maps.new2.uniquemaps.webp": "41d4e3c8",
  "items/maps.atlas2maps.new2.webp": "88efd184",
  "items/maps.atlas2maps.new3.uniquemaps.webp": "42c8ff67",
  "items/maps.atlas2maps.new3.webp": "e1e3ff6b",
  "items/maps.atlas2maps.new4.uniquemaps.webp": "51549dba",
  "items/maps.atlas2maps.new4.webp": "6083f03b",
  "items/maps.atlas2maps.webp": "c98d0e55",
  "items/maps.atlasmaps.notnamed.webp": "b5ff2a88",
  "items/maps.atlasmaps.webp": "70d44827",
  "items/maps.webp": "10019492",
  "items/pets.webp": "b5460e62",
  "items/questitems.glyphs.webp": "ef0731c8",
  "items/questitems.heist.webp": "0d4d9646",
  "items/questitems.hellscape.webp": "3e35d87a",
  "items/questitems.sentinel.webp": "02d97c36",
  "items/questitems.webp": "3813e030",
  "items/quivers.shards.webp": "da460b84",
  "items/quivers.webp": "b5bd8ed8",
  "items/relics.mediumrelics.webp": "c9474e99",
  "items/relics.webp": "763aeb58",
  "items/rings.webp": "9d6ee7a2",
  "items/skillicons.passives.ascendants.webp": "3df557b2",
  "items/skillicons.passives.assassin.webp": "8ee2584b",
  "items/skillicons.passives.atlastrees.webp": "fb053204",
  "items/skillicons.passives.berserker.webp": "af490a26",
  "items/skillicons.passives.champion.webp": "522871e9",
  "items/skillicons.passives.chieftain.webp": "d4e62567",
  "items/skillicons.passives.deadeye.webp": "1eedd54a",
  "items/skillicons.passives.elementalist.webp": "5a31cb77",
  "items/skillicons.passives.gladiator.webp": "dcbba855",
  "items/skillicons.passives.guardian.webp": "03621d24",
  "items/skillicons.passives.hierophant.webp": "7901f4a9",
  "items/skillicons.passives.inquistitor.webp": "6e7b9aba",
  "items/skillicons.passives.juggernaut.webp": "f8033d37",
  "items/skillicons.passives.necromancer.webp": "1557c402",
  "items/skillicons.passives.occultist.webp": "2ef4bb9d",
  "items/skillicons.passives.pathfinder.webp": "72ae0944",
  "items/skillicons.passives.primalist.webp": "97070630",
  "items/skillicons.passives.raider.webp": "02c25460",
  "items/skillicons.passives.saboteur.webp": "45781738",
  "items/skillicons.passives.slayer.webp": "9addd339",
  "items/skillicons.passives.trickster.webp": "6de60ce9",
  "items/skillicons.passives.voodooshaman.webp": "a74f2e03",
  "items/skillicons.passives.warden.webp": "813fb09b",
  "items/skillicons.passives.webp": "f37bb2ed",
  "items/skillicons.vaal skill icons.webp": "20348379",
  "items/skillicons.webp": "b26cf3b1",
  "items/weapons.onehandweapons.claws.webp": "eb7806fc",
  "items/weapons.onehandweapons.daggers.webp": "4fe66210",
  "items/weapons.onehandweapons.onehandaxes.webp": "caa5354e",
  "items/weapons.onehandweapons.onehandmaces.webp": "e2ab7f10",
  "items/weapons.onehandweapons.onehandswords.harbingerleagueshards.webp": "bf2b4c08",
  "items/weapons.onehandweapons.onehandswords.webp": "27a20ae1",
  "items/weapons.onehandweapons.rapiers.webp": "f51dc808",
  "items/weapons.onehandweapons.scepters.webp": "a5d5674e",
  "items/weapons.onehandweapons.wands.webp": "77a80f1e",
  "items/weapons.twohandweapons.bows.webp": "9f97d4ac",
  "items/weapons.twohandweapons.fishingrods.webp": "a5f6e818",
  "items/weapons.twohandweapons.staves.harbingershards.webp": "efde27c2",
  "items/weapons.twohandweapons.staves.webp": "fd2f6e43",
  "items/weapons.twohandweapons.twohandaxes.webp": "984f5753",
  "items/weapons.twohandweapons.twohandmaces.webp": "64e03f64",
  "items/weapons.twohandweapons.twohandswords.webp": "6fcf9049",
  "passive_tree_azmeri.bundle": "a7c158cc",
  "passive_tree_common.bundle": "1df57bcc",
  "passive_tree_dex.bundle": "535236a0",
  "passive_tree_dexint.bundle": "42ac738f",
  "passive_tree_icons.bundle": "546ca460",
  "passive_tree_int.bundle": "937a90e0",
  "passive_tree_str.bundle": "3579fee8",
  "passive_tree_strdex.bundle": "a6982f16",
  "passive_tree_strdexint.bundle": "826cce82",
  "passive_tree_strint.bundle": "2f738c70",
  "tree318.json": "04d29c96",
  "tree319.json": "4ecfad61",
  "tree320.json": "4ecfad61",
  "tree321.json": "ec987e73",
  "tree322.json": "9dc4339c",
  "tree323.json": "a771e8b3",
  "tree324.json": "641ff58e",
  "tree325.json": "c2dd5e19",
  "tree326.json": "e0d4a9e7",
  "tree3261.json": "554e441a",
  "uniques.json": "70929a1b"
} as Record<string, string>
  